
/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
    width?: number;
    height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 12, height = 12 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 12" fill="none">
    <g clipPath="url(#clip0_22805_5089)">
      <path d="M4.96823 7.75012C4.92359 7.57709 4.8334 7.41918 4.70703 7.29282C4.58067 7.16646 4.42276 7.07626 4.24973 7.03162L1.18223 6.24062C1.12989 6.22577 1.08383 6.19425 1.05103 6.15085C1.01823 6.10744 1.00049 6.05453 1.00049 6.00012C1.00049 5.94572 1.01823 5.89281 1.05103 5.8494C1.08383 5.806 1.12989 5.77448 1.18223 5.75962L4.24973 4.96812C4.4227 4.92353 4.58057 4.83341 4.70693 4.70714C4.83328 4.58088 4.92351 4.42307 4.96823 4.25012L5.75923 1.18262C5.77393 1.13008 5.80542 1.0838 5.84889 1.05082C5.89235 1.01785 5.94542 1 5.99998 1C6.05454 1 6.1076 1.01785 6.15107 1.05082C6.19453 1.0838 6.22602 1.13008 6.24073 1.18262L7.03123 4.25012C7.07586 4.42316 7.16606 4.58107 7.29242 4.70743C7.41878 4.83379 7.57669 4.92399 7.74973 4.96862L10.8172 5.75912C10.87 5.77367 10.9165 5.80513 10.9496 5.84866C10.9828 5.8922 11.0008 5.94541 11.0008 6.00012C11.0008 6.05484 10.9828 6.10805 10.9496 6.15159C10.9165 6.19512 10.87 6.22657 10.8172 6.24112L7.74973 7.03162C7.57669 7.07626 7.41878 7.16646 7.29242 7.29282C7.16606 7.41918 7.07586 7.57709 7.03123 7.75012L6.24023 10.8176C6.22552 10.8702 6.19403 10.9165 6.15057 10.9494C6.1071 10.9824 6.05404 11.0002 5.99948 11.0002C5.94492 11.0002 5.89185 10.9824 5.84839 10.9494C5.80492 10.9165 5.77343 10.8702 5.75873 10.8176L4.96823 7.75012Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 1.5V3.5" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11 2.5H9" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2 8.5V9.5" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.5 9H1.5" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_22805_5089">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;


